import PinCodeForm from "./PinCodeForm";
import withStyles from "react-jss";
import styles from "./styles";
import { Form } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// export default withStyles(styles)(PinCodeForm);
var mapStateToProps = function (state) {
    return {
        didCodeVerificationFailed: state.auth.errors.didCodeVerificationFailed
    };
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({}, dispatch);
};
export default Form.create({ name: "virification" })(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PinCodeForm)));



//////////////////
// WEBPACK FOOTER
// ./src/components/PinCodeForm/index.tsx
// module id = 716
// module chunks = 0